import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from 'urql';
import Swal from 'sweetalert2';
import PageHeader from '@/components/common/PageHeader.jsx';
import ProveedorForm from './ProveedorForm.jsx';
import { Q_PROVEEDOR, M_UPDATE_PROVEEDOR } from '@/graphql/suppliers.gql.js';
import { withIdempotencyKey } from '@/utils/idempotency.js';

export default function EditarProveedor() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [result] = useQuery({
    query: Q_PROVEEDOR,
    variables: { id },
    pause: !id,
  });
  const [, updateSupplier] = useMutation(M_UPDATE_PROVEEDOR);

  const supplier = useMemo(() => result.data?.proveedor, [result.data]);
  const queryError = result.error;

  const handleSubmit = async input => {
    const resultMutation = await updateSupplier({ id, input }, withIdempotencyKey('proveedor-update'));
    if (resultMutation.error) {
      console.error('Error actualizando proveedor:', resultMutation.error); // eslint-disable-line no-console
      await Swal.fire('No pudimos actualizar el proveedor', resultMutation.error.message, 'error');
      return;
    }
    if (!resultMutation.error) {
      await Swal.fire({
        title: 'Proveedor actualizado',
        text: 'Los cambios se guardaron correctamente.',
        icon: 'success',
        timer: 1500,
        showConfirmButton: false,
      });
      navigate('/admin/proveedores', { replace: true });
    }
  };

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title={supplier ? supplier.razon_social : 'Editar proveedor'}
        description="Actualizá datos fiscales, de contacto o estado operativo del proveedor."
        breadcrumbs={[
          { label: 'Administración', href: '/admin' },
          { label: 'Proveedores', href: '/admin/proveedores' },
          { label: supplier ? supplier.razon_social : 'Editar proveedor' },
        ]}
      />

      {queryError && !result.fetching ? (
        <div className="flex h-64 items-center justify-center rounded-2xl border border-[rgba(var(--danger,255_99_99),0.35)] bg-[rgba(var(--danger,255_99_99),0.08)]">
          <span className="text-sm text-[rgb(var(--danger,255_99_99))]">
            {queryError.message || 'No pudimos cargar el proveedor.'}
          </span>
        </div>
      ) : result.fetching ? (
        <div className="flex h-64 items-center justify-center rounded-2xl border border-[rgba(var(--border),0.4)] bg-[rgba(var(--panel),0.6)]">
          <span className="text-sm text-[rgba(var(--muted),0.85)]">Cargando datos del proveedor...</span>
        </div>
      ) : supplier ? (
        <ProveedorForm
          initialValues={supplier}
          onSubmit={handleSubmit}
          onCancel={() => navigate(-1)}
          submitLabel="Guardar cambios"
          cancelLabel="Cancelar"
        />
      ) : (
        <div className="flex h-64 items-center justify-center rounded-2xl border border-[rgba(var(--border),0.4)] bg-[rgba(var(--panel),0.6)]">
          <span className="text-sm text-[rgba(var(--muted),0.85)]">No encontramos el proveedor solicitado.</span>
        </div>
      )}
    </div>
  );
}
